import { Input } from '@verlo/shared/components/ui/input';

/**
 * The six digits from an authenticator app (#179). A plain input rather than six boxes:
 * `one-time-code` lets a phone or a password manager fill it, and paste just works.
 */
const CodeInput = ({ value, onChange, id, autoFocus = true, ...props }) => (
  <Input
    id={id}
    inputMode="numeric"
    autoComplete="one-time-code"
    pattern="[0-9]*"
    maxLength={6}
    placeholder="123456"
    autoFocus={autoFocus}
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
    className="font-mono text-center text-lg tracking-[0.4em]"
    required
    {...props}
  />
);

export default CodeInput;
